
import { Box, Flex, Text } from '@chakra-ui/react';
import { formatDuration } from '@/utils/volunteerHours';

interface ProfileInfoProps {
  firstName?: string;
  lastName?: string;
  role?: string;
  age?: number | string;
  hours?: number | string;
  tshirtSize?: string;
  showStats?: boolean;
}

export function ProfileInfo({ firstName, lastName, role, age, hours, tshirtSize, showStats = true }: ProfileInfoProps) {
  return (
    <Flex flexDir="column" align="center" mb="24px" px="20px">
      <Text as="h1" fontSize="24px" fontWeight="semibold" color="volyx.text" mb="4px" textAlign="center" m="0">
        {firstName} {lastName}
      </Text>
      <Text fontSize="16px" color="volyx.textSecondary" mb={showStats ? '16px' : '0'} mt="0">{role}</Text>
      {showStats && (
        <Flex align="center" bg="volyx.lightGray" p="16px" borderRadius="16px" w="full" maxW="400px">
          <Flex flex="1" flexDir="column" align="center">
            <Text as="span" fontSize="20px" fontWeight="semibold" color="volyx.text" mb="4px">{age || '-'}</Text>
            <Text as="span" fontSize="14px" color="volyx.textSecondary">Age</Text>
          </Flex>
          <Box w="1px" h="40px" bg="volyx.borderLight" />
          <Flex flex="1" flexDir="column" align="center">
            <Text as="span" fontSize="20px" fontWeight="semibold" color="volyx.text" mb="4px">{formatDuration(hours)}</Text>
            <Text as="span" fontSize="14px" color="volyx.textSecondary">Hours</Text>
          </Flex>
          <Box w="1px" h="40px" bg="volyx.borderLight" />
          <Flex flex="1" flexDir="column" align="center">
            <Text as="span" fontSize="20px" fontWeight="semibold" color="volyx.text" mb="4px">{tshirtSize || '-'}</Text>
            <Text as="span" fontSize="14px" color="volyx.textSecondary">Size</Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}
